import React, { useState, useEffect, useMemo } from "react";
import { EyeOutlined,BarsOutlined } from "@ant-design/icons";
import {
  Layout,
  theme,
  ConfigProvider,
  FloatButton,
  Input,
  Row,
  Form,
  Typography,
  Checkbox,
  Col,
  Card,
  Table,
  Spin,
  Select,
  Breadcrumb,
  Button,
} from "antd";
import { useNavigate } from "react-router-dom";
import { BOM } from "../../../services/definedMethod";

import TableStatus from "../../../config/data/TableViewStatus.json";
import cnt from "../../../services/definedConstant";
import MainLayout from "../../../components/layouts/MainLayout";
import { connect, useDispatch } from "react-redux";
import { apiConfig, labelConfig, staticConfig } from "../teller.config";
import { rightAction } from "../../../redux/actions";
import DownloadTableButtons from "../../../components/DownloadTableButtons";
import TopContent from "../../../components/layouts/TopContent";

const { Text, Link, Title } = Typography;
const Search = Input;
const { manageSalesTransactionItems, monthList } = staticConfig;

const Teller = (props) => {
  const navigate = useNavigate();

  //DECLARED VARIABLES
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const [tellerList, setTellerList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [originalList, setOriginalList] = useState([]);
  const [tableCount, setTableCount] = useState("10");
  const [selectedRow, setSelectedRow] = useState(null);
  const dispatch = useDispatch();

  const columns = [
    {
      title: "User Name",
      dataIndex: "userName",
    },
    {
      title: "Teller Description",
      dataIndex: "tellerDescription",
    },
    {
      title: "Status",
      dataIndex: "status",
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
    },
    {
      title: "End Date",
      dataIndex: "endDate",
    },
    {
      title: "Vault Actions",
      dataIndex: "vaultActions",
      render: (_, record) => (
        <div style={{ display: "flex" }}>
          <Button
            type="link"
            icon={<BarsOutlined />}
            onClick={() => console.log(record)}
          ></Button>

          <Button type="link" onClick={() => console.log(record)}>
            Allocate Cash
          </Button>
          <Button type="link" onClick={() => console.log(record)}>
            Settle Cash
          </Button>

          <Button
            type="link"
            icon={<EyeOutlined style={{ color: "black" }} />}
            onClick={() => console.log(record)}
          ></Button>
        </div>
      ),
    },
  ];

  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value?.toLowerCase();
    // console.log(searchKey);

    if (!searchKey) {
      setTellerList(originalList);
      return;
    }
    const filterBySearch = originalList.filter(
      (item) =>
        item?.key === parseInt(searchKey) ||
        item?.accountNo?.toLowerCase()?.includes(searchKey.toLowerCase())
    );
    setTellerList(filterBySearch);
  }

  function selectTableCount(value) {
    setTableCount(value);
  }
  //END METHODS DECLARED
  useEffect(() => {
    //DISABLE ALL RIGHTSIDEBAR ACTION
    dispatch({
      type: cnt.CLEAR_RIGHT_BTN,
    });
    rightAction(cnt.RIGHT_ADD_BTN);

    getChequeDeposit();
  }, []);

  const getChequeDeposit = () => {
    let body = {
      session,
    };


    const url = apiConfig.Customizedteller + `/${77}/tellers`;
    console.log(url);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objList = res;
        console.log(res);
        let tempCodeList = [];
        objList.forEach((element) => {
          tempCodeList.push({
            key: element?.id,
            id: element?.id,
            tellerDescription:"Test till",
            userName: "DemoUser",
            status: "status",
            startDate:"01 January 2001",
            endDate:"15 February 2024" ,
          });
        });

        setTellerList(tempCodeList);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempCodeList);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  function handleOnView() {
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/detail-tlo1000", { state: { id: selectedRow.id } });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [cnt.RIGHT_DETAIL_BTN].map((item) => {
      dispatch({
        type: item,
      });
    });
  };

  return (
    <MainLayout isEnableRightSidebar={true} onView={handleOnView}>
      <TopContent
        pageTitle={labelConfig.manageLinkUserToTillTeller}
        pageItems={staticConfig.manageLinkUserToTillTellerItems}
      />

      {/* RENDER TABLE LIST */}
      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text style={{ marginRight: 8 }}>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text style={{ marginLeft: 8 }}>Entries</Text>
            </div>

            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Filter by name/external ID..."
                style={{
                  width: 400,
                }}
              />
            </div>
            <DownloadTableButtons
              downloadData={tellerList}
              columns={columns}
              fileName={"Till List"}
            />
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={tellerList}
            bordered
            pagination={{
              position: ["bottomCenter"],
              pageSize: tableCount,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };

export default connect(mapStateToProps, mapDispatchToProps)(Teller);

// const columns = [
//     {
//         title: "User Name",
//         dataIndex: "userName",
//     },
//     {
//         title: "Teller Description",
//         dataIndex: "tellerDescription",
//     },
//     {
//         title: "Status",
//         dataIndex: "status",
//     },
//     {
//         title: "Start Date",
//         dataIndex: "startDate",
//     },
//     {
//         title: "End Date",
//         dataIndex: "endDate",
//     },
//     {
//         title: "Vault Actions",
//         dataIndex: "vaultActions",
//     },
// ];
